<template>
  <v-flex data-qa="loandetails-flex-u236fn">
    <v-layout row wrap data-qa="loandetails-layout-y92miu">
      <Loader v-if="loaderEnabled"/>
      <v-layout wrap class="ml-2" data-qa="loandetails-layout-38nlbq">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          :style="{ background: dashboardGradient }"
         data-qa="loandetails-flex-95sgqg">
          <v-container :class="{ 'pa-6 pl-12': !$vuetify.breakpoint.smAndDown }" data-qa="loandetails-container-1c2a9m">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="loandetails-flex-qmiad6">
              <v-row no-gutters data-qa="loandetails-row-2tij8">
                <v-layout row wrap align-center class="pb-2" data-qa="loandetails-layout-0c1tb9">
                    <inline-svg
                      class="mt-2"
                      :src="getNavigationIcon()"
                      width="50"
                      height="50"
                      aria-label="Navigation Icon"
                    ></inline-svg>
                    <v-layout column class="pb-2" data-qa="loandetails-layout-l437ji">
                      <font class="display-1 font-weight-thin white--text pt-4 pl-2"
                        >{{ $t("common.loanLabel") }}
                      </font>
                      <!--Product Description-->
                      <font
                        class="text-h5 font-weight-thin white--text pl-2" v-if="showProductDescription"
                        >{{ productDescription }}</font
                      >
                    </v-layout>
                </v-layout>
              </v-row>
              <v-row data-qa="loandetails-row-90zs95">
                <v-layout wrap class="pl-4" data-qa="loandetails-layout-6sa0qi">
                  <v-flex xs12 sm12 md12 lg9 xl9 data-qa="loandetails-flex-anuguc">
                    <v-layout row wrap data-qa="loandetails-layout-q6apf2">
                      <v-flex xs6 sm6 md6 lg5 xl4 class="px-1" data-qa="loandetails-flex-nwnmko">
                        <font
                          class="subheading-1 font-weight-medium white--text"
                          >{{ $t("loanDetails.loanId") }}
                        </font>
                        <br data-qa="loandetails-br-eyyori">
                        <font class="text-h5 font-weight-bold white--text">
                          {{ loanID }}</font
                        >
                      </v-flex>
                      <v-flex
                        v-if="mortgageID"
                        xs6 sm6 md6 lg4 xl4
                        class="px-1"
                       data-qa="loandetails-flex-98jo6">
                        <font
                          class="subheading-1 font-weight-medium white--text"
                          >{{ $t("mortgage.mortgageAgreementNo") }}
                        </font>
                        <br data-qa="loandetails-br-qp2cf9">
                        <font class="text-h5 font-weight-bold white--text">
                          {{ mortgageID }}</font
                        >
                        </v-flex>
                        <v-flex xs6 sm6 md6 lg4 xl4
                        class="px-1" data-qa="loandetails-flex-eoonwe">
                         <font
                          class="subheading font-weight-medium white--text"
                          >{{ $t("accountDetails.outstandingBalance") }}</font
                          >
                          <br data-qa="loandetails-br-oqj2nb">
                          <font class="text-h5 font-weight-bold white--text">{{
                            outstandingBalance
                          }}</font>
                        </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg2 xl2 class="text-right ma-3" v-if="enableRedemptionQuoteOption && checkLoanStatusAndlimit && ((isSmeLogin && enableRoleBasedAccess) ? isPermissionGranted.redemptionQuote : true)" data-qa="loandetails-flex-ucmap">
                    <v-btn
                      @click="goToRedemptionHome()"
                      color="white"
                      class="text-none py-2 px-4"
                      outlined
                       data-qa="loandetails-btn-c728vu">{{ $t("redemptionQuoteLabels.label") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12 data-qa="loandetails-flex-h5we3">
          <v-tabs v-model="currentTab" :color="primaryColor" class="pl-2" data-qa="loandetails-tabs-um9zh">
            <v-tab v-for="(n, i) in totalTabs.length" :key="n" :data-qa="`loandetails-tab-2j8v1-${i}`">
              <font class="subtitle-1 text-capitalize font-weight-bold">
                {{ getTabLabel(n) }}
              </font>
            </v-tab>
          </v-tabs>
          <v-container fluid data-qa="loandetails-container-t4dud">
            <v-tabs-items v-model="currentTab" data-qa="loandetails-tabs-items-0bhobl">
              <!-- Details Tab -->
              <v-tab-item data-qa="loandetails-tab-item-vt0t2j">
                <v-row
                  v-if="(isSmeLogin  && enableRoleBasedAccess) ? isPermissionGranted.details : true"
                  :style="{ background: defaultBackgroundColor }"
                  class="pl-2"
                  data-qa="loandetails-row-f4rr9r">
                  <v-card tile class="py-2 pt-4" data-qa="loandetails-card-2cn80g">
                    <DisplayDetails
                      v-if="loanDetails.length"
                      :config="{
                        title: $t('loanDetails.displayDataLabels.loanDetails'),
                        dataList: loanDetails,
                        valueListLabels: ['coApplicant'],
                        valueInList: [
                          { label: 'coApplicant', content: coApplicants },
                        ],
                        translation: 'loanDetails.displayDataLabels',
                      }"
                      class="pl-5 pb-4"
                    />
                    <v-divider data-qa="loandetails-divider-0ike4p"
                      v-if="repaymentDetails && repaymentDetails.length"
                      class="pa-3"
                    />
                    <DisplayDetails
                      v-if="repaymentDetails.length"
                      :config="{
                        title: $t(
                          'loanDetails.displayDataLabels.repaymentDetails'
                        ),
                        dataList: repaymentDetails,
                        translation: 'loanDetails.displayDataLabels',
                      }"
                      class="pl-5"
                    />
                    <v-divider data-qa="loandetails-divider-p3tk67"
                      v-if="mandateDetails && mandateDetails.length"
                      class="pa-3"
                    />
                    <DisplayDetails
                      v-if="mandateDetails.length"
                      :config="{
                        title: $t(
                          'loanDetails.displayDataLabels.mandateDetails'
                        ),
                        dataList: mandateDetails,
                        translation: 'loanDetails.displayDataLabels',
                      }"
                      class="pl-5"
                    />
                    <v-divider data-qa="loandetails-divider-camtnt"
                      v-if="chargeDetails && chargeDetails.length"
                      class="pa-3"
                    />
                    <DisplayDetails
                      v-if="chargeDetails.length"
                      :config="{
                        title: $t(
                          'loanDetails.displayDataLabels.chargeDetails'
                        ),
                        dataList: chargeDetails,
                      }"
                      class="pl-5"
                    />
                  </v-card>
                </v-row>
                <v-row
                  v-if="(isSmeLogin && enableRoleBasedAccess) ? !isPermissionGranted.details : false"
                  no-gutters
                  justify="center"
                  class="ma-6 ml-0"
                >
                  <div outlined class="text-center pa-6">
                    <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                      <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                    </p>
                  </div>
                </v-row>
              </v-tab-item>
              <!-- Repayment Schedule Tab -->
              <v-tab-item data-qa="loandetails-tab-item-ytkyi5">
                <v-data-table
                  v-if="(isSmeLogin && enableRoleBasedAccess) ? isPermissionGranted.repayments : true"
                  :headers="repaymentHeaders"
                  :items="repaymentSchedule"
                  class="elevation-1"
                  :custom-sort="customSort"
                 data-qa="loandetails-data-table-eunf89"></v-data-table>
                 <v-row
                  v-if="(isSmeLogin && enableRoleBasedAccess) ? !isPermissionGranted.repayments : false"
                  no-gutters
                  justify="center"
                  class="ma-6 ml-0"
                >
                  <div outlined class="text-center pa-6">
                    <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                      <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                    </p>
                  </div>
                </v-row>
              </v-tab-item>
              <!-- Transactions Tab -->
              <v-tab-item xl12 lg12 sm10 xs12 data-qa="loandetails-tab-item-o2m7ld">
                <v-row v-if="(isSmeLogin && enableRoleBasedAccess) ? isPermissionGranted.transactions : true" :style="{ background: defaultBackgroundColor }" data-qa="loandetails-row-spa09f">
                  <Transactions
                    :loanConfig="{ loanStartDate, loanTenor, loanMaturityDate }"
                  />
                </v-row>
                <v-row
                  v-if="(isSmeLogin && enableRoleBasedAccess) ? !isPermissionGranted.transactions : false"
                  no-gutters
                  justify="center"
                  class="ma-6 ml-0"
                >
                  <div outlined class="text-center pa-6">
                    <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                      <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                    </p>
                  </div>
                </v-row>
              </v-tab-item>
              <!-- Loan Payment Tab -->
              <v-tab-item :style="{ background: defaultBackgroundColor }" v-if="!isSmeLogin" data-qa="loandetails-tab-item-gupbx9">
                <LoanPayment
                  v-if="(isSmeLogin && enableRoleBasedAccess) ? isPermissionGranted.repayments : true"
                  :loanPaymentConfig="{
                    accountNumber: loanID,
                    loanStatus,
                    resetData: resetLoanPaymentScreen,
                    outstandingBalance: this.outstandingBalanceAmount,
                    loanCurrency,
                  }"
                />
                <v-row
                  v-if="(isSmeLogin && enableRoleBasedAccess) ? !isPermissionGranted.repayments : false"
                  no-gutters
                  justify="center"
                  class="ma-6 ml-0"
                >
                  <div outlined class="text-center pa-6">
                    <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                      <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                    </p>
                  </div>
                </v-row>
              </v-tab-item>
              <!-- Statements -->
              <v-tab-item data-qa="loandetails-tab-item-4ccqd">
                <v-row v-if="isSmeLogin ? isPermissionGranted.statements : true">>
                <v-list v-if="eStatementList.length" class="px-5" data-qa="loandetails-list-hrqsd">
                  <v-list-item-content
                    v-for="(statement, index) in eStatementList"
                    :key="index"
                   :data-qa="`loandetails-list-item-content-oa4uxt-${index}`">
                    <v-card-text class="pa-2" :data-qa="`loandetails-card-text-ggc8tm-${index}`">
                      <v-layout wrap :data-qa="`loandetails-layout-jbowq-${index}`">
                        <v-flex xs12 sm12 md12 lg6 xl7 :data-qa="`loandetails-flex-vky85-${index}`">
                          <span
                            class="body-1 font-weight-regular"
                            v-text="statement.data"
                           :data-qa="`loandetails-span-5vg9fj-${index}`"></span>
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg5 xl5 :data-qa="`loandetails-flex-qli7j5-${index}`">
                          <v-btn
                            @click="
                              downloadStatement('view', statement.documentId)
                            "
                            text
                            :color="primaryColor"
                            :data-qa="`loandetails-btn-65ng9q-${index}`">
                            <v-icon left class="material-symbols-outlined" :data-qa="`loandetails-icon-8u6gw-${index}`">visibility</v-icon>
                            <font class="body-2 font-weight-regular">
                              {{ $t("consolidatedStatement.viewBtn") }}</font
                            >
                          </v-btn>
                          <v-btn
                            @click="
                              downloadStatement(
                                'download',
                                statement.documentId
                              )
                            "
                            text
                            :color="primaryColor"
                            :data-qa="`loandetails-btn-iyuqo-${index}`">
                            <v-icon left class="material-symbols-outlined" :data-qa="`loandetails-icon-0dgmv8-${index}`">download</v-icon>
                            <font class="body-2 font-weight-regular">{{
                              $t("consolidatedStatement.downloadBtn")
                            }}</font>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-divider :data-qa="`loandetails-divider-prbt24-${index}`"  v-if="!(index === eStatementList.length - 1)" />
                  </v-list-item-content>
                </v-list>
                <v-row
                  v-if="
                    (!eStatementList.length && noStatementsAvail) ||
                    (!eStatementList.length && noStatementFound)
                  "
                  no-gutters
                  justify="center"
                  class="ma-6 ml-0"
                 data-qa="loandetails-row-g62ay">
                  <v-sheet outlined class="text-center pa-6" color="#FAFAFA" data-qa="loandetails-sheet-2c4h1">
                    <v-icon x-large :color="primaryColor" class="pb-3"
                       data-qa="loandetails-icon-7p1gif">mdi-file-document</v-icon
                    >
                    <p v-if="noStatementsAvail" class="ma-6 mt-0 px-12" data-qa="loandetails-p-0o9tql">
                      {{ $t("accountStatements.noStatementsAvailable") }}
                    </p>
                    <p v-if="noStatementFound" class="ma-6 mt-0 px-12" data-qa="loandetails-p-eqj0vn">
                      {{ $t("accountStatements.noStatementFound") }}
                    </p>
                  </v-sheet>
                </v-row>
                </v-row>
                <v-row
                  v-if="isSmeLogin ? !isPermissionGranted.statements : false"
                  no-gutters
                  justify="center"
                  class="ma-6 ml-0"
                >
                  <div outlined class="text-center pa-6">
                    <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                      <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                    </p>
                  </div>
                </v-row>
              </v-tab-item>
              <!-- Generated Quotes -->
              <v-tab-item data-qa="loandetails-tab-item-2sj7hr">
                <v-container v-if="(isSmeLogin && enableRoleBasedAccess) ? isPermissionGranted.redemptionQuote : true" data-qa="loandetails-container-l5jv1">
                  <v-list v-if="generatedQuoteList.length" class="px-5" data-qa="loandetails-list-hgrls">
                    <v-list-item-content
                      v-for="(quote, index) in generatedQuoteList"
                      :key="index"
                     :data-qa="`loandetails-list-item-content-ds0gm8-${index}`">
                      <v-card-text class="pa-2" :data-qa="`loandetails-card-text-feogj-${index}`">
                        <v-layout wrap :data-qa="`loandetails-layout-zycaz-${index}`">
                          <v-flex xs12 sm12 md12 lg7 xl7 :data-qa="`loandetails-flex-fljoqe-${index}`">
                            <span
                              class="body-1 font-weight-regular"
                              v-text="quote.data"
                              :data-qa="`loandetails-span-2lpdr-${index}`"></span>
                          </v-flex>
                          <v-flex xs12 sm12 md12 lg5 xl5 :data-qa="`loandetails-flex-peu9ln-${index}`">
                            <v-btn
                              @click="downloadQuote('view', quote.documentId)"
                              text
                              :color="primaryColor"
                              :data-qa="`loandetails-btn-dnsyhy-${index}`">
                              <v-icon left class="material-symbols-outlined" :data-qa="`loandetails-icon-utblwh-${index}`">visibility</v-icon>
                              <font class="body-2 font-weight-regular">
                              {{
                                $t("consolidatedStatement.viewBtn")
                              }}</font>
                            </v-btn>
                            <v-btn
                              @click="downloadQuote('download', quote.documentId, quote.data)"
                              text
                              :color="primaryColor"
                              :data-qa="`loandetails-btn-lcrfxv-${index}`">
                              <v-icon left class="material-symbols-outlined" :data-qa="`loandetails-icon-gh4y4g-${index}`">download</v-icon>
                              <font class="body-2 font-weight-regular">{{
                                $t("consolidatedStatement.downloadBtn")
                              }}</font>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-divider :data-qa="`loandetails-divider-2ajdpm-${index}`"  v-if="!(index === generatedQuoteList.length - 1)" />
                    </v-list-item-content>
                  </v-list>
                  <v-row v-if="(!generatedQuoteList.length && noQuoteAvail)" no-gutters justify="center" class="ma-6" data-qa="loandetails-row-yzz3cs">
                    <v-sheet outlined class="text-center pa-6" color="#FAFAFA" data-qa="loandetails-sheet-zhkmn">
                      <v-icon x-large :color="primaryColor" class="pb-3"
                         data-qa="loandetails-icon-ctmwmn">mdi-file-document</v-icon
                      >
                      <p class="ma-6 mt-0 px-12" data-qa="loandetails-p-5hs1h3">
                        {{ $t("redemptionQuoteLabels.noQuotesAvailable") }}
                      </p>
                    </v-sheet>
                  </v-row>
                </v-container>
                <v-row
                  v-if="(isSmeLogin && enableRoleBasedAccess) ? !isPermissionGranted.redemptionQuote : false"
                  no-gutters
                  justify="center"
                  class="ma-6 ml-0"
                >
                  <div outlined class="text-center pa-6">
                    <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                      <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
                    </p>
                  </div>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-flex>
        <!-- Doc preview -->
        <PDFPreview v-if="viewPDF" :PDFData="PDFData" @closePdfPreview="viewPDF= false"/>
      </v-layout>
    </v-layout>
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
  </v-flex>
</template>

<script>
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import Transactions from '@/views/accounts/LoanTransactions'
import LoanPayment from '@/views/payments/TransferFunds/loanPayment/LoanPayment.vue'
import ConfirmExit from '@/components/common/ConfirmExit.vue'
import commonService from '@/service/commonService.js'
import appSettings from '@/plugins/appSettings'
import event from '@/util/event'
import store from '@/core/store'
import PDFPreview from '@/components/common/PDFPreview.vue'
import Loader from '../../../components/common/Loader.vue'

export default {
  name: 'LoanDetails',
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  components: {
    Loader,
    Transactions,
    DisplayDetails,
    LoanPayment,
    ConfirmExit,
    PDFPreview
  },
  data () {
    return {
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      appSettings,
      resetLoanPaymentScreen: false,
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: '',
      eStatementList: [],
      generatedQuoteList: [],
      noStatementsAvail: true,
      noStatementFound: false,
      noQuoteAvail: true,
      loaderEnabled: false,
      statementDoc: undefined,
      viewPDF: false,
      PDFData: undefined,
      totalTabs: [
        this.$t('loanDetails.detailsLabel'),
        this.$t('loanDetails.repaymentSchedule'),
        this.$t('loanDetails.transactionsLabel'),
        this.$t('loanDetails.loanPaymentLabel'),
        this.$t('loanDetails.statements'),
        this.$t('loanDetails.generatedQuotesTab')
      ],
      enableMortgageSection: this.$appSettings.defaultConfigurations.landingPageConfig.enableMortgageSection,
      repaymentHeaders: [
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.repaymentNumber'
          ),
          value: 'repaymentNumber'
        },
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.repaymentDate'
          ),
          value: 'repaymentDate'
        },
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.repaymentAmount'
          ),
          value: 'repaymentAmount'
        },
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.principalAmount'
          ),
          value: 'principalAmount'
        },
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.interestAmount'
          ),
          value: 'interestAmount'
        },
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.outstandingBalance'
          ),
          value: 'outstandingBalance'
        },
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.scheduleChargeAmount'
          ),
          value: 'scheduleChargeAmount'
        },
        {
          text: this.$t(
            'loanDetails.repaymentScheduleTable.headers.taxScheduleCharge'
          ),
          value: 'taxScheduleCharge'
        }
      ],
      repaymentSchedule: [],
      loanID: undefined,
      loanStatus: '',
      loanMandateReference: undefined,
      mortgageID: '',
      currentTab: 0,
      sourceScreen: '',
      loanAccountDetails: {},
      loanDetails: [],
      repaymentDetails: [],
      mandateDetails: [],
      chargeDetails: [],
      coApplicants: [],
      outstandingBalance: undefined,
      outstandingBalanceAmount: undefined,
      loanStartDate: undefined,
      loanTenor: undefined,
      loanCurrency: undefined,
      isLeavingRoute: false,
      isLogout: false,
      loanInfo: '',
      loanMaturityDate: '',
      PaymentCompleted: false,
      loanPenaltyInterest: {},
      enableLoanSection: this.$appSettings.defaultConfigurations.landingPageConfig.enableLoanSection,
      showActualLoanAccountStaus: this.$appSettings.defaultConfigurations.loanScreen.showActualLoanAccountStatus,
      showProductDescription: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableProductDescriptionInBanner,
      productDescription: '',
      enableRedemptionQuoteOption: this.$appSettings.defaultConfigurations.loanScreen.redemptionQuote.enableRedemptionQuoteOption,
      showGeneratedQuotesTab: this.$appSettings.defaultConfigurations.loanScreen.showGeneratedQuotesTab,
      permissions: [],
      permissionsRequired: {
        details: 'LOAN_VIEW_DETAILS',
        transactions: 'LOAN_VIEW_TRANSACTIONS',
        schedule: 'VIEW_LOAN_REPAYABLE_SCHEDULE',
        repayments: 'LOAN_REPAYMENT',
        redemptionQuote: 'REDEMPTION_QUOTE',
        statements: 'LOAN_VIEW_AND_DOWNLOAD_STATEMENTS'
      },
      isPermissionGranted: {
        details: false,
        transactions: false,
        schedule: false,
        repayments: false,
        redemptionQuote: false,
        statements: false
      },
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  async created () {
    if (this.isSmeLogin) {
      this.totalTabs = this.totalTabs.filter(tab => tab !== this.$t('loanDetails.loanPaymentLabel'))
    }

    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.isPermissionGranted = {
      details: (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.permissionsRequired?.details) : true,
      transactions: (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.permissionsRequired?.transactions) : true,
      statements: (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.permissionsRequired?.statements) : true,
      schedule: (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.permissionsRequired?.schedule) : true,
      repayments: (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.permissionsRequired?.repayments) : true,
      redemptionQuote: (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.permissionsRequired?.redemptionQuote) : true
    }

    if (!this.showGeneratedQuotesTab) {
      this.totalTabs = this.totalTabs.filter(tab => tab !== this.$t('loanDetails.generatedQuotesTab'))
    }
    this.fromDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 1)
    )
      .toISOString()
      .substr(0, 10)
    this.loanID = this.$route.params ? this.$route.params.loanId : ''
    if (this.loanID) {
      await this.getLoanAccountDetails(this.loanID)
      await this.getListOfAccountStatements()
      await this.getListOfQuotes()
    }
    event.$on('showLoanDetails', (arg) => {
      this.currentTab = 0
      this.resetLoanPaymentScreen = true
      this.getLoanAccountDetails()
    })
    event.$on('amendLoanData', (loanData) => {
      this.loanInfo = loanData
      if (Object.values(this.loanInfo).length) {
        this.PaymentCompleted = false
      }
    })
    event.$on('isTransfer', (payment) => {
      this.PaymentCompleted = payment
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
  },
  computed: {
    checkLoanStatusAndlimit () {
      const loanStatus = ['SETTLED', 'RESTRUCTURED', 'COMPLETED', 'SOLD', 'FUNDS-RELEASED']
      return !loanStatus.includes(this.loanStatus?.toUpperCase()) && new Date() < new Date(this.loanMaturityDate)
    }
  },
  updated () {
    this.mortgageID = (this.enableMortgageSection && this.sourceScreen === 'Mortgage') || !this.enableLoanSection
      ? this.loanAccountDetails.loanAgreementId || this.$route.params.mortgageAgreement
      : ''
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // access to component's instance using `vm` .
      // this is done because this navigation guard is called before the component is created.
      vm.sourceScreen = from.name
      next()
    })
  },
  beforeRouteLeave (to, from, next) {
    if (
      this.loanInfo &&
      (this.loanInfo.selectedAccountNumber ||
        this.loanInfo.transferAmount ||
        this.loanInfo.transferNote) &&
      !this.PaymentCompleted
    ) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  },
  beforeMount () {
    if (!this.loanID) {
      // this.goBack() // Fix DOB-909
      this.$router.push('/home')
    }
  },
  methods: {
    customSort (items, sortBy, sortDesc) {
      if (sortBy[0] === 'repaymentDate') {
        return items.sort((a, b) => {
          const dateA = this.parseDate(a.repaymentDate)
          const dateB = this.parseDate(b.repaymentDate)

          if (sortDesc[0]) {
            return dateB - dateA
          } else {
            return dateA - dateB
          }
        })
      } else {
        if (sortBy.length === 0) return items

        return items.sort((a, b) => {
          const sortA = this.convertCurrencyToNumber(a[sortBy[0]])
          const sortB = this.convertCurrencyToNumber(b[sortBy[0]])
          if (sortDesc[0]) {
            return sortA < sortB ? 1 : -1
          } else {
            return sortA > sortB ? 1 : -1
          }
        })
      }
    },
    parseDate (dateString) {
      const [day, month, year] = dateString.split('-')
      return new Date(year, month - 1, day)
    },
    convertCurrencyToNumber (cur) {
      return parseFloat(cur.toString().replace(/[^0-9.-]+/g, ''))
    },
    goBack () {
      return this.$router.go(-1)
    },
    getTabLabel (index) {
      return this.totalTabs[index - 1]
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    async getListOfAccountStatements () {
      const details = {
        businessType: 'ACCOUNT',
        businessValue: this.loanID,
        docType: 'LOAN-STATEMENT',
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      const response = await commonService.getListOfAccDocStatements(details)
      if (response && response.items) {
        this.noStatementsAvail = false
        this.eStatementList = []
        response.items.forEach((item) => {
          const fromDate = this.$formatter.formatDate(item.fromDate)
          const toDate = this.$formatter.formatDate(item.toDate)
          this.eStatementList.push({
            data: `${fromDate.replaceAll('-', '/')} - ${toDate.replaceAll(
              '-',
              '/'
            )}`,
            documentId: item.documentId
          })
        })
      } else {
        this.eStatementList = []
        this.noStatementsAvail = false
        this.noStatementFound = true
      }
      // this.loaderEnabled = false
    },
    async downloadStatement (type, documentId) {
      const body = {
        businessType: 'ACCOUNT',
        businessValue: this.loanID,
        docType: 'LOAN-STATEMENT'
      }
      const response = await commonService.downloadStatement(documentId, body)

      if (response && !response.causes) {
        const userLoginId = sessionStorage.getItem('userId')
          ? JSON.parse(sessionStorage.getItem('userId'))
          : JSON.parse(sessionStorage.getItem('username'))
        const fileName = `E-Statement-${userLoginId}.pdf`
        // const blobObject = new Blob([response], { type: 'application/pdf' })
        // const fileURL = window.URL.createObjectURL(blobObject)
        if (type === 'view') {
          this.PDFData = response
          this.viewPDF = true
        } else {
          if (response && !response.causes) {
            // positive response
            // this.downloadFile(fileURL, fileName)
            var a = document.createElement('a') // Create <a data-qa="loandetails-a-tj5gf28">
            a.href = response // Image Base64 Goes here
            a.download = fileName
            a.click()
          }
        }
      }
    },
    async getListOfQuotes () {
      const details = {
        businessType: 'ACCOUNT',
        businessValue: this.loanID,
        docType: 'LOAN-REDEMPTION-QUOTE',
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      const response = await commonService.getListOfAccDocStatements(details)
      if (response && response.items) {
        this.noQuoteAvail = false
        this.generatedQuoteList = []
        response.items.forEach((item) => {
          // const fromDate = item.fromDate ? this.$formatter.formatDate(item.fromDate) : ''
          // const toDate = item.toDate ? this.$formatter.formatDate(item.toDate) : ''
          this.generatedQuoteList.push({
            data: item.generationDate,
            documentId: item.documentId
          })
        })
      } else {
        this.generatedQuoteList = []
        this.noQuoteAvail = true
      }
      // this.loaderEnabled = false
    },
    async downloadQuote (type, documentId, generationDate) {
      const body = {
        businessType: 'ACCOUNT',
        businessValue: this.loanID,
        docType: 'LOAN-REDEMPTION-QUOTE'
      }
      const response = await commonService.downloadStatement(documentId, body)

      if (response && !response.causes) {
        const timestamp = '00-00-00' // As timestamp isn't available in response API
        const fileName = `LEN_LoanRedemptionQuote_QUOTE7831_${generationDate}_${timestamp}.pdf`
        // const blobObject = new Blob([response], { type: 'application/pdf' })
        // const fileURL = window.URL.createObjectURL(blobObject)
        if (type === 'view') {
          this.PDFData = response
          this.viewPDF = true
        } else {
          if (response && !response.causes) {
            // positive response
            // this.downloadFile(fileURL, fileName)
            var a = document.createElement('a') // Create <a data-qa="loandetails-a-760zor">
            a.href = response // Image Base64 Goes here
            a.download = fileName
            a.click()
          }
        }
      }
    },
    async getLoanAccountDetails () {
      this.loaderEnabled = true
      try {
        const response = await commonService.getLoanAccountDetails(
          this.loanID
        )
        if (response) {
          this.loanDetails = []
          this.repaymentDetails = []
          this.repaymentSchedule = []
          this.chargeDetails = []
          this.loanAccountDetails = response
          this.loanStatus = response?.loanStatus
          this.loanStartDate = response.loanStartDate
          this.loanTenor = `${response.loanTerm?.value} ${response.loanTerm?.calendarPeriod}`
          this.loanCurrency = response.loanAmount?.currency
          this.loanMaturityDate = response.maturityDate
          this.loanPenaltyInterest = response.penaltyInterestOutstanding
          this.loanMandateReference = response.mandateReference
          this.outstandingBalance = this.$formatter.currency.format(
            response.principalOutstanding.amount,
            response.principalOutstanding.currency
          )
          this.outstandingBalanceAmount =
              response.principalOutstanding.amount
          this.productDescription = response.productName
          // Loan Details
          this.loanDetails.push(
            {
              label: 'productName',
              value: response.productName
            },
            {
              label: 'loanStatus',
              value: response.loanStatus
                ? this.showActualLoanAccountStaus
                  ? response.loanStatus
                  : this.resolveSimpleMortgageStatus(this.$t(`loanDetails.loanStatus.${response.loanStatus}`))
                : ''
            },
            {
              label: 'loanOutstandingAmount',
              value: this.$formatter.currency.format(
                response.principalOutstanding.amount,
                response.principalOutstanding.currency
              )
            },
            {
              label: 'initialLoanAmount',
              value: this.$formatter.currency.format(
                response.loanAmount.amount,
                response.loanAmount.currency
              )
            },
            {
              label: 'loanTerm',
              value: `${response.loanTerm?.value} ${response.loanTerm?.calendarPeriod} (s)`
            },
            {
              label: 'loanPurpose',
              value: response.loanPurpose
            },
            {
              label: 'interestRate',
              value: response.interestRate
                ? `${response.interestRate}% - ${response.interestRateType}`
                : 'NA'
            },
            {
              label: 'totalDisbursedAmount',
              value: this.$formatter.currency.format(
                response.disbursementDetails.totalDisbursedAmount.amount,
                response.disbursementDetails.totalDisbursedAmount.currency
              )
            },
            {
              label: 'loanStartDate',
              value: this.$formatter.formatDate(response.loanStartDate)
            },
            {
              label: 'maturityDate',
              value: this.$formatter.formatDate(response.maturityDate)
            },
            {
              label: 'principalOutstanding',
              value: this.$formatter.currency.format(
                response.principalOutstanding.amount,
                response.principalOutstanding.currency
              )
            },
            {
              label: 'interestOutstanding',
              value: response.interestOutstanding
                ? this.$formatter.currency.format(
                  response.interestOutstanding.amount,
                  response.interestOutstanding.currency
                )
                : 'NA'
            },
            {
              label: 'arrearPrincipalOutstanding',
              value: this.$formatter.currency.format(
                response.arrearPrincipalOutstanding.amount,
                response.arrearPrincipalOutstanding.currency
              )
            },
            {
              label: 'arrearInterestOutstanding',
              value: this.$formatter.currency.format(
                response.arrearInterestOutstanding.amount,
                response.arrearInterestOutstanding.currency
              )
            },
            {
              label: 'annualPercentageRate',
              value: response && response?.annualPercentageRate >= 0
                ? `${response.annualPercentageRate}%`
                : 'NA'
            },
            {
              label: 'sortCode',
              value: this.$appSettings.defaultConfigurations.sortCode
            }
          )
          if (
            response.penaltyInterestOutstanding &&
              response.penaltyInterestOutstanding.amount > 0
          ) {
            this.loanDetails.push({
              label: 'penaltyInterest',
              value: this.$formatter.currency.format(
                response.penaltyInterestOutstanding.amount,
                response.penaltyInterestOutstanding.currency
              )
            })
          }
          if (response.loanApplicants && response.loanApplicants.length > 1) {
            const coApplicants = []
            const isSmeLogin = sessionStorage.getItem('isSmeLogin')
              ? JSON.parse(sessionStorage.getItem('isSmeLogin'))
              : ''
            const defaultCorporateCode = sessionStorage.getItem('defaultCorporateCode')
              ? JSON.parse(sessionStorage.getItem('defaultCorporateCode'))
              : ''
            const userLoginId = sessionStorage.getItem('customerCode')
              ? JSON.parse(sessionStorage.getItem('customerCode'))
              : JSON.parse(sessionStorage.getItem('username'))
            response.loanApplicants.forEach((applicant) => {
              // Push the all the co-applicants customerId excluding the one logged-in
              if (isSmeLogin ? (defaultCorporateCode !== applicant.customerId) : (userLoginId !== applicant.customerId)) {
                coApplicants.push({
                  value: `${applicant.customerName} - ${applicant.customerId}`
                })
              }
            })
            this.coApplicants = coApplicants
            this.loanDetails.push({
              label: 'coApplicant',
              value: coApplicants
            })
          }
          if (
            response.feeCollectionAccount &&
              response.feeCollectionAccount > 0
          ) {
            this.loanDetails.push({
              label: 'chargeFundAcc',
              value: response.feeCollectionAccount
            })
          }
          // Exclusion List of Loan Details
          this.loanDetails = this.loanDetails.filter(item =>
            !this.$appSettings.uiFieldsDisplayConfigurations.loanDetailsList.exclusionList.includes(item.label)
          )
          // Repayment Details
          this.repaymentDetails.push(
            {
              label: 'nextRepaymentAmount',
              value: response?.repaymentSchedule?.length > 0
                ? this.$formatter.currency.format(
                  response?.repaymentSchedule[0]?.repaymentAmount.amount,
                  response?.repaymentSchedule[0]?.repaymentAmount.currency
                ) : '-'
            },
            {
              label: 'repaymentType',
              value: response?.repaymentType
            },
            {
              label: 'nextRepaymentDate',
              value: response?.repaymentSchedule?.length > 0 ? this.$formatter.formatDate(response?.repaymentSchedule[0].repaymentDate) : '-'
            },
            {
              label: 'repaymentFrequency',
              value: response?.repaymentFrequency
            }
          )
          // if (response.repaymentAccount) {
          //   this.repaymentDetails.push({
          //     label: 'repaymentAccount',
          //     value: response.repaymentAccount
          //   })
          // }
          // Loan Mandate Details
          // const payload = {
          //   linkedAccountId: this.loanID
          // }
          // const mandateResponse = await commonService.getLoanMandateDetails(
          //   payload
          // )

          // Loan Direct Debit Mandate Details
          if (this.loanMandateReference) {
            const payload = {
              loanId: this.loanID,
              mandateReference: this.loanMandateReference
            }
            const mandateResponse = await commonService.getloanDirectDebitMandateDetails(
              payload
            )
            if (
              mandateResponse && mandateResponse?.mandateReference
            ) {
              this.mandateDetails.push(
                {
                  label: 'debitAccountId',
                  value: mandateResponse?.debitAccountId
                },
                {
                  label: 'mandateStatus',
                  value: mandateResponse?.mandateStatus
                },
                {
                  label: 'debitBankName',
                  value: `${mandateResponse?.debitBankName} (${mandateResponse?.debitBankIdentifier})`
                }
              )
            }
          }
          // Exclusion List of Loan Repayment Details
          this.repaymentDetails = this.repaymentDetails.filter(item =>
            !this.$appSettings.uiFieldsDisplayConfigurations.loanRepaymentList.exclusionList.includes(item.label)
          )
          // Charge Details
          if (
            response.loanChargeHistory &&
              response.loanChargeHistory.length
          ) {
            response.loanChargeHistory.forEach((data, index) => {
              this.chargeDetails.push({
                label: data.chargeDescription,
                value: this.$formatter.currency.format(
                  data.chargeAmount.amount,
                  data.chargeAmount.currency
                )
              })
            }
            )
          }
          // repayment schedule table content
          response.repaymentSchedule.forEach((schedule) => {
            this.repaymentSchedule.push({
              repaymentNumber: schedule.repaymentNumber,
              repaymentDate: this.$formatter.formatDate(
                schedule.repaymentDate
              ),
              repaymentAmount: this.$formatter.currency.format(
                schedule.repaymentAmount.amount,
                schedule.repaymentAmount.currency
              ),
              principalAmount: this.$formatter.currency.format(
                schedule.principalAmount.amount,
                schedule.principalAmount.currency
              ),
              interestAmount: this.$formatter.currency.format(
                schedule.interestAmount.amount,
                schedule.interestAmount.currency
              ),
              outstandingBalance: this.$formatter.currency.format(
                schedule.outstandingBalance.amount,
                schedule.outstandingBalance.currency
              ),
              scheduleChargeAmount: this.$formatter.currency.format(
                schedule.scheduleChargeAmount.amount,
                schedule.scheduleChargeAmount.currency
              ),
              taxScheduleCharge: this.$formatter.currency.format(
                schedule.taxScheduleCharge.amount,
                schedule.taxScheduleCharge.currency
              )
            })
          })
        }
        this.loaderEnabled = false
      } catch (e) {
        this.loaderEnabled = false
        console.log(e)
      }
    },
    getCustomerName () {
      const data = store.getters['profileStore/profileData'].customerDetails
      if (data) {
        this.accountName = data.fullName || 'Roger Moore'
        return this.accountName
      }
    },
    getNavigationIcon () {
      return this.getSvgIconSrc('Loan_Dashboard')
    },
    goToRedemptionHome () {
      this.$router.push({
        name: 'RedemptionQuote',
        params: { loanId: this.loanID, mortgageAgreement: this.mortgageID, loanStatus: this.loanStatus, maturityDate: this.loanMaturityDate }
      })
    },
    resolveSimpleMortgageStatus (essenceStatus) {
      var loanStatus = essenceStatus
      const activeStatuses = ['NORMAL', 'INARREARS', 'FORREVERSAL', 'SETTLEMEMTREQUESTED', 'FUNDS-RELEASED', 'RENEGOCIATED', 'RESTRUCTURED', 'SALE-REQUESTED']
      const closedStatuses = ['SETTLED', 'RESTRUCTURED-SETTLED', 'COMPLETED', 'SOLD', 'WRITTENOFF', 'PARTIALWRITEOFF', 'REVERSED']
      if (activeStatuses.includes(essenceStatus.toUpperCase())) {
        loanStatus = 'Active'
      } else if (closedStatuses.includes(essenceStatus.toUpperCase())) {
        loanStatus = 'Closed'
      }
      return loanStatus
    }
  }
}
</script>
